import React, { useState } from "react";

import HeaderOne from "../components/header/HeaderOne";

import { Link } from "react-router-dom";
import FooterOne from "../components/footer/FooterOne";
import Breadcrumb from "./Breadcrumb";
import BlogOne from "../components/blog/BlogOne";

function ProjectThree() {
  const breadcrumbs = [
    { label: "Ana Sayfa", link: "/" },
    { label: "Kalite Yönetim Sistemi ve Belgelerimiz" },
  ];
  return (
    <div className="">
      <HeaderOne />

      <Breadcrumb
        title="Kalite Yönetim Sistemi ve Belgelerimiz"
        breadcrumbs={breadcrumbs}
      />
      <BlogOne />

      <FooterOne />
    </div>
  );
}

export default ProjectThree;
